{{if !$data.isShow}}
{{if $data.hasAni}}
<div class="fe-article sider-group-item" id="_siderGroupItem{{$data.index}}">
{{else}}
<div class="fe-article">
{{/if}}
    <div class="section _section">
        <div class="section-header _listTitle">
            <h3 class="title"><span class="iconfont {{$data.iconName}}"></span>{{$data.name}}</h3>
            <span class="iconfont icon-shouqi title-arrow arrow _titleArrow"></span>
        </div>
        <div class="section-main _listMain">
            {{if $data.isShowFullList}}
            <ul class="_currMenuList menu-list">
                {{each $data.list}}
                
                <li class="item _currFilterBtn" data-search="{{$data.searchType}}" data-key="{{$value.alias}}" data-type="{{$data.type}}" data-name="{{$data.key}}">
                    <h4 class="fl subtitle  _subTitle">{{ if $data.type == 1}}{{ $value.name}}{{else}}{{$value.value}}{{/if}}</h4>
                    <span class="fr subtitle-desc">({{$value.count}})</span>
                </li>
                {{/each}}
            </ul>
                {{if $data.isShowTime}}
                <div class="form-group-time clearfix">
                    <div class="form-inline">
                        <input type="text" name="{{$data.timeStart}}" maxlength="4" class="form-control _startYear" readonly placeholder="年">
                    </div>
                    <div class="form-inline conjuction">
                        <span></span>
                    </div>
                    <div class="form-inline">
                        <input type="text" name="{{$data.timeEnd}}" maxlength="4" class="form-control _endYear" readonly placeholder="年" value="">
                    </div>
                    <div class="form-inline">
                        <a href="javascript:;" class="fe-btn btn-radius btn-active _submitTime" value="">确认</a>
                    </div>
                </div>
                {{else}}
                <div class="see-more">
                    <a href="javascript:;" role="button" class="_showFullList">
                        <span class="_indicatorText">更多</span>
                        <span class="_indicatorText" style="display:none">收起</span>
                        <i class="iconfont icon-xialajiantou arrow _showFullListArrow"></i>
                    </a>
                </div>
                {{/if}}
            {{else}}
            <div class="selected-filter-item" data-type="{{$data.type}}" data-search="{{$data.searchType}}" data-key="{{$data.alias}}" data-name="{{$data.key}}">
                <span class="title _subTitle">{{$data.selectedName}}</span>
                <span class="fr iconfont icon-guanbi3 _closeSelectedFilter"></span>
            </div>
            {{/if}}
        </div>
    </div>
</div>
{{/if}}